import { ReplacementProductDetailFragment } from '@src/fragments/ProductPricing.generated'
import { CarouselProduct } from '../DynamicProductCarousel/DynamicProductCardTypes'

/**
 * The replacement product carousel gets a ReplacementProductDetailFragment from the API.
 * Our carousels use a standard CarouselProduct type for rendering and analytics functions.
 * The ReplacementProductDetailFragment is nearly the same but lacks a productKey and isMarketplace value.
 * We want to tack these on quickly to make this product type compatible with standard carousel inputs.
 *
 * @param products | type ReplacementProductDetailFragment
 * @returns CarouselProduct[] or empty []
 */
export const conformReplacementProductToCard = (
  products: ReplacementProductDetailFragment[] | undefined | null
): CarouselProduct[] | [] => {
  if (!products) {
    return []
  }

  return products.map((product) => ({
    ...product,
    productKey: product.productNumber,
    isMarketplace: false, // Since marketplace data isn't present on the replacement product response we can assume it is false.
  }))
}
